import {
  actionTypes
} from '../actions/loading';

const ACTION_HANDLERS = {
  [actionTypes.SET_LOADING]: (state, action) => ({ loading: action.payload })
};

const initialState = { loading: false };
export default function loadingReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
